























































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { EbtoResponse, EbtoTransferStep, EbtoCampaign, EbtoUserFinalizeRequest, CampaignDecision } from "@/shared/types";

import { formatCurrency } from "@/shared/currency";
import * as _ from "lodash";
import moment from "moment";
import { EbtoRetained, } from "@/employee/route-names";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import TransferStepsWidget from "@/employee/components/ebto/TransferStepsWidget.vue";
import SendConfirmationEmail from "@/employee/components/ebto/SendConfirmationEmail.vue";
import OfferSummary from "@/employee/components/ebto/OfferSummary.vue";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {
    HsabLoginWrapper,
    TransferStepsWidget,
    SendConfirmationEmail,
    OfferSummary
  }
})
export default class TransferCompleted extends Vue {
  ebtoStore = useEbtoStore();

  moment = moment;

  formatCurrency = formatCurrency;
  EbtoTransferStep = EbtoTransferStep;
  currentStep = EbtoTransferStep.Confirm;
  isSubmitting = false;
  decision = CampaignDecision.TransferOut;

  get hasIncentiveBonus (): boolean {
    return this.ebtoStore.incentiveAmount > 0;
  }

  get hasPricingOffer (): boolean {
    return (this.hasIncentiveBonus || (this.ebtoStore.isFeeWaived));
  }

  get showOffer (): boolean {
    return (this.hasPricingOffer || this.ebtoStore.isFeeWaived);
  }

  get isConfirmStep (): boolean {
    return (this.currentStep === EbtoTransferStep.Confirm);
  }

  claimStayOffer (): void {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.ebtoStore.finalizeEbtoStayOffer({
      decision: CampaignDecision.Stay,
      userId: this.ebtoStore.verifiedUser.userId,
      eSignName: ""
    }).then(() => {
      this.isSubmitting = false;
      if (this.ebtoStore.isUserFlowComplete) {
        this.$router.push({ name: EbtoRetained });
      }
    });
  }
}
